"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _MaskedInput = _interopRequireDefault(require("../masked-input/MaskedInput"));

var _Input = _interopRequireDefault(require("../input/Input"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var maskOptions = {
  mask: '(000) 000-0000'
};

function PhoneNumberInput(props) {
  return /*#__PURE__*/_react.default.createElement(_MaskedInput.default, Object.assign({}, props, {
    inputMode: "tel",
    maskOptions: maskOptions
  }));
}

PhoneNumberInput.propTypes = _objectSpread({}, _Input.default.propTypes);
var _default = PhoneNumberInput;
exports.default = _default;
